import { Divider, Grid } from "@material-ui/core";
import React from 'react';



const ClientiRowsTable = (props) => {





    return (

        <Grid container>
            {props.clienti.map((c, idx) => {
                return (
                    <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container>
                            <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={6} sm={6} md={6} lg={6} xl={6}>


                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.numeClient}</span>
                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{c.nume}</span>

                            </Grid>

                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.facturi}</span>
                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{c.facturi}</span>

                            </Grid>
                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.sold} {props.an}</span>
                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{c.sold}</span>

                            </Grid>



                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>



                                <i onClick={() => { props.editClienti(c) }} style={{ cursor: 'pointer' }} className='material-icons'>edit</i>




                            </Grid>
                        </Grid>
                        <Divider className='pm-divider' style={{ marginTop: 20 }} />
                    </Grid>
                )
            })}



        </Grid>

    )
}



export default ClientiRowsTable;